import { Accordion, FlexyButton, useModal } from '@europrocurement/flexy-components';
import {
    CollectionDeDossierJsonldCollectiondossierRead,
    ReglementsEtAcomptesCBJsonldAcompteRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { Box, Card, PaletteColor, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { addIcon } from '@europrocurement/l2d-icons';
import { FactureFormaliteApiObject } from '@europrocurement/l2d-domain';
import CollectionProvision from '../../../CollectionProvision/CollectionProvision';
import ProvisionAdd from '../../../ProvisionAdd/ProvisionAdd';

type EncaissementsSectionProps = {
    collections: CollectionDeDossierJsonldCollectiondossierRead[];
    totalAcomptes: number;
    totalReglements: number;
    afterSubmitAcompte: () => void;
    reglements: ReglementsEtAcomptesCBJsonldAcompteRead[];
    acomptes: ReglementsEtAcomptesCBJsonldAcompteRead[];
    handleValidateInvoice: (invoice: FactureFormaliteApiObject) => Promise<void>;
};

const EncaissementsSection: React.FunctionComponent<EncaissementsSectionProps> = function ({
    collections,
    totalAcomptes,
    totalReglements,
    afterSubmitAcompte,
    reglements,
    acomptes,
    handleValidateInvoice,
}: EncaissementsSectionProps) {
    const { modalActions } = useModal();
    const { palette } = useTheme();

    return (
        <Card
            id="encaissements"
            sx={{ boxShadow: 'none', padding: 0 }}
        >
            <Accordion
                sx={{
                    boxShadow: 'none',
                }}
                title="Encaissements"
                titlesSx={{
                    fontWeight: '600',
                    boxShadow: 'none',
                }}
                headerSx={{ boxShadow: 'none' }}
                expanded
                expandColor={palette.text.primary as unknown as PaletteColor}
                expandLabel={
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            <Typography
                                variant="l2dh7"
                                sx={{ marginRight: '10px', fontSize: '0.875rem' }}
                            >
                                Total encaissé :
                            </Typography>
                            <Typography
                                variant="l2dh7"
                                sx={{ color: 'text.primary' }}
                            >
                                {` ${totalAcomptes + totalReglements} €`}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            <Typography
                                variant="l2dh7"
                                sx={{ marginRight: '10px', fontSize: '0.875rem' }}
                            >
                                Crédit restant :
                            </Typography>
                            <Typography
                                variant="l2dh7"
                                sx={{ color: 'text.secondary' }}
                            >
                                {` ${totalAcomptes}
                                    €`}
                            </Typography>
                        </Box>
                    </Box>
                }
                footerActions={
                    collections.length === 1
                        ? [
                              <Box
                                  sx={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'end',
                                      alignItems: 'center',
                                      gap: '10px',
                                  }}
                              >
                                  <FlexyButton
                                      variant="outlined"
                                      color={palette.primary.dark}
                                      onClick={() => {
                                          modalActions.call(
                                              <ProvisionAdd
                                                  collectionId={collections[0].id as number}
                                                  afterSubmit={afterSubmitAcompte}
                                              />,
                                              true,
                                              false,
                                          );
                                      }}
                                      icon={addIcon}
                                      label="Ajouter un encaissement"
                                  />
                              </Box>,
                          ]
                        : []
                }
            >
                <CollectionProvision
                    acomptes={[...acomptes]}
                    reglements={[...reglements]}
                    afterSubmit={afterSubmitAcompte}
                    handleValidateInvoice={handleValidateInvoice}
                />
            </Accordion>
        </Card>
    );
};

export default EncaissementsSection;
